module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warpper"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding-bottom": "25px"
    }
  }, [_vm._m(2, false, false), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--primary btn-add",
    attrs: {
      "disabled": _vm.isDisabled,
      "type": "button"
    },
    on: {
      "click": _vm.goWechatAuth
    }
  }, [_vm._v("\n        重新添加微信公众号\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner_wrapper"
  }, [_c('img', {
    attrs: {
      "src": require("./img/warning.png"),
      "alt": "警告提示"
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("授权失败")]), _vm._v(" "), _c('p', [_vm._v("仅支持认证的服务号授权，请检查您的公众号类型")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("绑定微信公众号")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "steps"
  }, [_c('li', [_c('strong', [_c('span', [_vm._v("Step")]), _vm._v("1")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./img/step1_valid_error.jpg"),
      "alt": "step1"
    }
  }), _vm._v(" "), _c('p', [_vm._v("检查公众号是否认证"), _c('br'), _vm._v("公众号名片是否有认证的标志")])]), _vm._v(" "), _c('li', [_c('strong', [_c('span', [_vm._v("Step")]), _vm._v("2")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./img/step2_valid_error.jpg"),
      "alt": "step1"
    }
  }), _vm._v(" "), _c('p', [_vm._v("检查公众号是否服务号"), _c('br'), _vm._v("只有出现在微信首页的是服务号"), _c('br'), _vm._v("被折叠在订阅号里的不是")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-def14f92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicauth/failed.vue
// module id = 840
// module chunks = 1